<div class="container-fluid content-wrapper">

  <div class="page-title-wrapper">
    <h1 class="page-title"> Stock Holdings </h1>
    <span class="page-subtitle">Closing Market Reports - Delivery Status</span>
  </div>

  <div class="row">
    <div class="col-12">
      <div *ngIf="filtersVisible">
        <form [formGroup]="filtersForm" class="filters-form">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label class="col-form-label">Search</label>
                <input class="form-control" type="text" (keyup)="search($event.target.value)" formControlName="search" placeholder="Search by any field...">
              </div>
            </div>
            <div class="col-sm-3">
              <div class="form-group">
                <label class="col-form-label">Founded before</label>
                <div class="input-group">
                  <input class="form-control" name="datepicker" formControlName="date" ngbDatepicker #datepicker="ngbDatepicker">
                  <div class="input-group-append">
                    <button class="btn datepicker-toggle-btn" (click)="datepicker.toggle()" type="button">
                      <i class="fas fa-calendar-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <!-- Industry chip input removed -->
          </div>
        </form>
      </div>

      <div class="row buttons-row no-gutters">
        <button class="col-sm-6 col-md-3 col-lg-2 filters-button" type="button" (click)="toggleFilters()">{{toggleFiltersLabel}}</button>
        <button class="col-sm-6 col-md-3 col-lg-2 filters-button" type="button" (click)="clearFilters()">Clear filters</button>
      </div>

      <div class="recent-orders row">
        <div class="col table-wrapper table-responsive">
          <table mat-table matSort [dataSource]="recentOrdersTableDataSource" class="table table-borderless table-sm recent-orders-table">

            <ng-container matColumnDef="id">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
              <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
              <td mat-cell *matCellDef="let element"> {{element.name}} </td>
            </ng-container>

            <ng-container matColumnDef="symbol">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Symbol </th>
              <td mat-cell *matCellDef="let element"> {{element.symbol}} </td>
            </ng-container>

            <ng-container matColumnDef="industry">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Industry </th>
              <td mat-cell *matCellDef="let element"> {{element.industry}} </td>
            </ng-container>

            <ng-container matColumnDef="location">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Location </th>
              <td mat-cell *matCellDef="let element"> {{element.location}} </td>
            </ng-container>

            <ng-container matColumnDef="employees">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Employee # </th>
              <td mat-cell *matCellDef="let element"> {{element.employees}} </td>
            </ng-container>

            <ng-container matColumnDef="stockprice">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Stock Price </th>
              <td mat-cell *matCellDef="let element" class="price-row"> ${{element.stockprice}} </td>
            </ng-container>

            <ng-container matColumnDef="date">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Date </th>
              <td mat-cell *matCellDef="let element"> {{element.date}} </td>
            </ng-container>

            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> EOD Report </th>
              <td [attr.cell-name]="'status'" [attr.cell-value]="element.status" mat-cell *matCellDef="let element">
                <span class="order-status">{{element.status}}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="recentOrdersTableDisplayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: recentOrdersTableDisplayedColumns;"></tr>
          </table>

          <mat-paginator class="table-paginator" [pageSizeOptions]="[5, 10, 25]" [pageSize]="5"></mat-paginator>
        </div>
      </div>
    </div>
  </div>
</div>
